export default {"src":"/_next/static/media/1.ccb95799.svg","height":38,"width":38};